import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class ImageModalService {

    public openModalRequest: EventEmitter<any> = new EventEmitter();
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/image-modal.service.ts